<template>
  <div>
    <v-card class="card-access-info">
        <h1 class="card-header">
            {{ $vuetify.lang.t('$vuetify.visitorForm.accessInformation') }}
        </h1>
        <v-form
            ref="form"
            v-model="valid">
            <div>
                <v-date-picker
                    v-model="form.dates"
                    :min="currentDate"
                    multiple
                    full-width
                    :error-messages="errors.dates">
                </v-date-picker>
            </div>
            <div
                v-if="form.dates.length >= 1"
                class="row time-content">
                <div class="col-6">
                    <hours-input
                        v-model="form.startTime"
                        :label="this.$vuetify.lang.t('$vuetify.visitorForm.startTime')"
                        default-value=""
                        :error-messages="errors.startTime"/>
                </div>
                <div class="col-6">
                    <hours-input
                        v-model="form.endTime"
                        :label="this.$vuetify.lang.t('$vuetify.visitorForm.endTime')"
                        default-value=""
                        :error-messages="errors.endTime"/>
                </div>
            </div>
        </v-form>
    </v-card>
  </div>
</template>

<script>
import HoursInput from '@/components/HoursInput.vue'
export default {
    name: 'VisitorAccessInfo',

    components: {
        HoursInput
    },

    props: {
        mode: {
            Type: String,
            default: ''
        },
        plans: {
            Type: Object,
            default: {}
        }
    },

    data () {
        return {
            currentDate: new Date().toISOString().slice(0, 10),
            form: this.getFormDateDefault(),
            errors: {
                dates: null,
                startTime: null,
                endTime: null
            },
            valid: true
        }
    },

    methods: {
        getFormDateDefault () {
            if (this.mode === 'edit') {
                return this.plans
            } else {
                return {
                    dates: [],
                    startTime: '',
                    endTime: ''
                }
            }
        },
        validateTimeByKey (key) {
            let isValid = true
            if (!this.form[key]) {
                this.errors[key] = this.$vuetify.lang.t('$vuetify.visitorForm.thisFieldIsRequired')
                isValid = false
            } else {
                this.errors[key] = null
            }

            return isValid
        },

        validateTimeFields () {
            const validatedKeys = ['startTime', 'endTime']
            if (this.form.dates.length > 0) {
                for (let i = 0; i < validatedKeys.length; i++) {
                    if (!this.validateTimeByKey(validatedKeys[i])) {
                        return false
                    }
                }

                // if more than 1 day, do not validate.
                if (this.form.dates.length <= 1) {
                    this.validateStartTime()
                    this.validateEndTime()
                }

                for (let i = 0; i < validatedKeys.length; i++) {
                    // if there is/are value in this.errors that means failed validation
                    if (this.errors[validatedKeys[i]]) {
                        return false
                    }
                }
            }

            return true
        },

        validateStartTime () {
            if (this.form.startTime && this.form.startTime > this.form.endTime) {
                this.errors.startTime = this.$vuetify.lang.t('$vuetify.visitorForm.StartInTimeMustBeLess')
            } else {
                this.errors.startTime = null
            }
        },

        validateEndTime () {
            if (this.form.endTime && this.form.endTime < this.form.startTime) {
                this.errors.endTime = this.$vuetify.lang.t('$vuetify.visitorForm.EndInTimeMustBeMore')
            } else {
                this.errors.endTime = null
            }
        },

        validateFrom () {
            return this.validateTimeFields()
        }
    },

    watch: {
        form: {
            handler: async function (newValue, oldValue) {
                this.$emit('input', newValue)
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.card-access-info {
    padding: 36px 0px;
    border-radius: 15px;
}
.card-header {
    font-size: 24px;
    font-weight: normal;
    color: #000;
    margin-bottom: 1rem;
    padding: 0px 46px;
}
.time-content {
    padding: 0px 46px;
}
</style>
